export default __webpack_public_path__ + "static/media/Henriette-Black.dd137b74.woff2";